import { render, staticRenderFns } from "./enterSimple.vue?vue&type=template&id=06012bba&scoped=true"
import script from "./enterSimple.vue?vue&type=script&lang=js"
export * from "./enterSimple.vue?vue&type=script&lang=js"
import style0 from "./enterSimple.vue?vue&type=style&index=0&id=06012bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06012bba",
  null
  
)

export default component.exports